<template>
  <div class="relative z-[1] pb-12">
    <DataGetter
      contentId="matches"
      eventToListen="none"
      :autoRefreshInterval="30000"
      @dataAvailable="
        data => {
          matches = data?.metaData?.topMatches || []
          loading = false
        }
        "
      @dataIsEmpty="()=>{
          matches = []

        loading = false
      }"
      :searchQuery="{ getLive: showLive, date: activeGroup.timestamp }"
    />
    <div class="py-2"></div>
    <!-- {{ showLive }}
    {{ matches[0]?.startTimestamp }} -->
    <!-- {{ activeGroup }}
     {{ matches[0]?.team1Name }} -->
    <div class="sticky w-full top-0 mb-[50vh] -mt-[50vh] h-0 z-[1]">
      <div
        class="bodyBg h-[40vw]"
        style="mask-image: linear-gradient(to bottom, black 80%, transparent)"
      ></div>
    </div>
    <div class="sticky top-0 z-[2] pb-0 pt-1">
      <div class="w-full overflow-auto pb-2 px-8">
        <div class="min-w-max flex">
          <div
            class="relative z-[2]"
            v-for="(group, i) in matchGroups"
            :key="i"
          >
            <div
              class="w-full h-full absolute top-0 left-0 duration-300"
              v-if="i == 0"
              :style="{
                transform: `translateX(calc(100% * ${activeGroup.index || 0}))`,
              }"
            >
              <div
                class="absolute w-full h-full rounded-content-sm overflow-hidden"
              >
                <div class="w-[20vw] h-[50%] bg-[#8684ff]"></div>
                <div
                  class="w-[20vw] h-[20vw] bg-[#8684ff] -translate-y-1/2 rotate-45"
                ></div>
              </div>
            </div>
            <div
              @click="
                () => {
                  selectGroup(group)
                }
              "
              class="relative w-[20vw] h-[25vw] pb-[5vw] flex flex-col items-center"
            >
              <div class="py-2"></div>
              <div v-if="true" class="flex flex-col items-center">
                <div class="text-sm">
                  {{ months[group.month] }}
                </div>
                <div class="text-6xl text-white font-bold">
                  {{ group.date }}
                </div>
                <div class="font-bold">
                  {{ daysShort[(group.day - 1 + 7) % 7] }}
                </div>
              </div>
              <!-- <div class="text-5xl text-white" v-else>
                <span class="text-2xl rounded-full border px-4">LIVE</span>
              </div> -->
              <!-- <div
                class="absolute -top-3 bg-white px-3 rounded-full text-[#242c3b]"
                v-if="group.isLive"
              >
                live
              </div> -->
            </div>
          </div>
        </div>
        <!-- <div class="w-[18vw]"></div> -->
      </div>
      <div class="flex justify-end w-full px-6 -top-6 relative">
        <InputComponent
          type="toggle"
          label="Voir Matches en cours"
          class="!w-content !bg-transparent !my-0 !p-[0] [&_label]:flex-row-reverse [&_label]:justify-start [&_label]:w-full [&_label]:w-left-0 [&_label]:gap-4"
          v-model="showLive"
        />
      </div>
    </div>
    <div>
      <div class="px-4 group relative matchesScrollContainer">
        <div v-if="loading || matches?.length" class="flex flex-col gap-4">
          <div
            class=" "
            v-for="(match, i) in loading ? shimmerMatches : matches || []"
            :key="i"
          >
            <div class="h-full rounded-[20px] ripple" @click="showMatch(match)">
              <!-- <div
              class="shimmerElement h-[70px]"
              v-if="
                !match?.matchStatus ||
                match?.shimmer
              "
            ></div> -->
              <div class="h-full" :class="{ 'shimmerElementRoundedDefault rounded-2xl': match.shimmer }">
                <div class="flex items-center gap-4">
                  <div
                    class="min-h-[70px] glassBg w-full px-4 py-7 rounded-2xl relative overflow-hidden"
                  >
                    <div
                      class="w-16 h-16 p-4 pt-5 pr-5 bg-[#002E5E] border border-primary-800 absolute -right-2 -top-2 rounded-full"
                    >
                      <img
                        src="@/assets/images/all/1xBetFull-white.svg"
                        alt=""
                        class="w-full h-full"
                      />
                    </div>
                    <div
                      class="grid grid-cols-3 gap-4 justify-between items-center"
                    >
                      <div
                        class="w-full flex flex-col gap-1 items-center justify-center"
                      >
                        <div class="w-[12vw] h-[12vw]">
                          <img
                            class="w-full object-contain object-center"
                            :src="match.team1Picture"
                            :key="match.team1Picture"
                            alt=""
                          />
                        </div>
                        <div
                          class="text-center h-[3lh] overflow-hidden flex items-center justify-center text-sm"
                        >
                          {{ match.team1Name }}
                        </div>
                      </div>
                      <div
                        class="flex flex-col items-center justify-center gap-2"
                      >
                        <div class="text-2xl" v-if="!match.isLive">
                          {{ match.startHour <= 9 ? 0 : ''
                          }}{{ match.startHour }} :
                          {{ match.startMin <= 9 ? 0 : '' }}{{ match.startMin }}
                        </div>
                        <div class="text-lg" v-else>
                          {{ match.liveDurationMin }}' min
                        </div>
                        <div
                          v-if="match.isLive"
                          class="grid grid-cols-3 gap-3 text-5xl"
                        >
                          <div>
                            {{ match.team1Score }}
                          </div>
                          <div>-</div>
                          <div>
                            {{ match.team2Score }}
                          </div>
                        </div>
                        <div
                          class="rounded-xl glassBg px-3 py-1 border flex gap-2 items-center"
                        >
                          <div>Cotes</div>
                          <div class="w-4 h-4">
                            <img
                              src="@/assets/images/all/eye-white.svg"
                              alt=""
                              class="w-full h-full"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        class="w-full flex flex-col gap-1 items-center justify-center"
                      >
                        <div class="w-[12vw] h-[12vw]">
                          <img
                            class="w-full object-contain object-center"
                            :src="match.team2Picture"
                            :key="match.team2Picture"
                            alt=""
                          />
                        </div>
                        <div
                          class="text-center h-[3lh] overflow-hidden flex items-center justify-center text-sm"
                        >
                          {{ match.team2Name }}
                        </div>
                      </div>
                    </div>
                    <div class="py-2"></div>
                    <div class="border-t"></div>
                    <div class="py-2"></div>
                    <div class="text-center text-sm">
                      {{ match.country }} &nbsp;
                      <span class="text-primary text-2xl relative top-1">
                        &bull;
                      </span>
                      &nbsp;
                      {{ match.league }}
                      <!-- {{ match.city }} -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="h-[40vh] w-full flex-col flex items-center justify-center"
          v-else
        >
          <div class="w-32 h-32">
            <img
              v-if="$ColorTheme.isLight()"
              src="@/assets/images/all/football.svg"
              alt=""
            />
            <img v-else src="@/assets/images/all/football-white.svg" alt="" />
          </div>
          <div class="py-4"></div>
          <div class="text-center text-2xl">
            {{ $t('matches.noLiveMatch') }}
          </div>
          <div class="text-center w-2/3">
            {{ $t('matches.noLiveMatchDescription') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import InputComponent from '../utils/InputComponent.vue'
import DataGetter from '../utils/DataGetter.vue'
// import filterIcon from '@/assets/images/all/filter.svg'
// import filterIconWhite from '@/assets/images/all/filter-white.svg'

export default defineComponent({
  name: 'groupedMatches',
  components: {
    DataGetter,
    InputComponent,
  },
  props: {},
  data() {
    return {
      loading: true,
      showLive: true,
      shimmerMatches: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      matches: {},
      eventsIds: [],
      activeGroup: {},
      matchGroups: new Array(30).fill('').map((el, i) => {
        const dayInMs = 24 * 3600 * 1000
        const timestamp = Date.now() + i * dayInMs
        const date = new Date(timestamp)
        return {
          hasLive: i == 0,
          index: i,
          day: date.getDay(),
          date: date.getDate(),
          month: date.getMonth(),
          year: date.getFullYear(),
          timestamp,
        }
      }),
      days: [
        'Lundi',
        'Mardi',
        'Mercredi',
        'Jeudi',
        'Vendredi',
        'Samedi',
        'Dimanche',
      ],
      daysShort: ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'],
      months: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ],
      monthsShort: [
        'Jan',
        'Fév',
        'Mar',
        'Avr',
        'Mai',
        'Juin',
        'Juil',
        'Août',
        'Sep',
        'Oct',
        'Nov',
        'Déc',
      ],
    }
  },
  mounted() {
    this.activeGroup = this.matchGroups[0]
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    showMatch(match) {
      this.$Events.dispatchEvent('match_detail_required', match)
    },
    showFilters() {
      this.$Events.dispatchEvent('show_filters_required')
    },
    selectGroup(group) {
      if (group.timestamp == this.activeGroup.timestamp) return
      this.activeGroup = group
      if (group.hasLive) this.showLive = true
      else this.showLive = false
      this.loading = true
    },
  },
  watch: {
    showLive(){
      this.loading = true
    }
  }
})
</script>

<style scoped>
/* .match0 {
  background: linear-gradient(169.09deg, #af8ffe 30.12%, #e294fe 87.39%);
}
.match1 {
  background: linear-gradient(169.09deg, #00aa8e 30.12%, #95d279 87.39%);
}
.match2 {
  background: linear-gradient(169.09deg, #e77672 30.12%, #ff8a86 87.39%);
} */
</style>
